module.exports = __webpack_public_path__ + "img/7Cantos@2x.d2308e01.png";